module.exports = __webpack_public_path__ + "static/media/busstops.459906a3.png";